var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldRender)?_c('transition',{attrs:{"name":"fade","appear":""}},[_c('error-messages',{staticClass:"subscriptions-require-account-notice"},[_vm._v("Purchasing a subscription requires an account.")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }